import { render, staticRenderFns } from "./SwapsPage.vue?vue&type=template&id=d64d62d8&scoped=true&"
import script from "./SwapsPage.vue?vue&type=script&lang=ts&"
export * from "./SwapsPage.vue?vue&type=script&lang=ts&"
import style0 from "./SwapsPage.vue?vue&type=style&index=0&id=d64d62d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64d62d8",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QBtn});
